import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '🟢',
    title: 'TOMO 1 — REFLEJOS EJECUTIVOS',
    desc: 'El sistema de entrenamiento para recuperar la velocidad de procesamiento y la reacción cognitiva que te permite seguir siendo el más lúcido de cualquier habitación. Velocidad de procesamiento visual · Aritmética mental · Atención visual sostenida · Velocidad de decisión · Stroop y ejercicios de inhibición · Secuencias numéricas avanzadas.'
  }, {
    icon: '🟡',
    title: 'TOMO 2 — MEMORIA DE COMANDO',
    desc: 'El sistema de entrenamiento de memoria diseñado para el hombre que necesita retener información crítica en su vida profesional y personal sin depender de apuntes ni del celular. Memoria de trabajo · Memoria de nombres · Memoria numérica · Palacio de la memoria · Memoria episódica · Evocación bajo presión.'
  }, {
    icon: '🟠',
    title: 'TOMO 3 — ARQUITECTURA LÓGICA',
    desc: 'El sistema de entrenamiento del razonamiento lógico y el análisis estructurado para el hombre que necesita seguir tomando las mejores decisiones de la habitación incluso cuando la presión es alta. Matrices lógicas · Resolución de problemas complejos · Pensamiento crítico · Razonamiento espacial verbal · Lógica deductiva e inductiva · Toma de decisiones estructurada.'
  }, {
    icon: '🔴',
    title: 'TOMO 4 — FOCO DE HIERRO',
    desc: 'El sistema de entrenamiento de la concentración para el hombre que sabe que su tiempo más valioso es el tiempo de foco profundo y que ese tiempo está siendo destruido por el entorno digital. Atención sostenida · Control de distracciones · Estado de flujo · Atención dividida · Foco bajo presión · Recuperación del foco.'
  }];
  const includes = ['Planificador de 4 semanas con progresión de dificultad', '40 a 60 ejercicios cognitivos con registro de resultado', 'Protocolos de entrenamiento con fichas de seguimiento', 'Evaluación inicial y final para medir el progreso real', 'Materiales imprimibles para usar sin pantalla', '100% adaptado al hombre argentino de 50+ en 2026'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-272">
      <div className="max-w-6xl mx-auto" data-id="element-273">
        <div className="text-center mb-12" data-id="element-274">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-275">
            <Book className="w-5 h-5" data-id="element-276" />
            <span data-id="element-277">EL SISTEMA</span>
          </div>
          <p className="text-white max-w-2xl mx-auto mb-4" data-id="element-278">
            No es una app de jueguitos con colores. No es un libro de autoayuda
            con teorías largas. No es material genérico para cualquier edad. Es
            un sistema completo, estructurado por capacidad cognitiva, diseñado
            específicamente para el hombre argentino de 50 a 65 años que no se
            deja estar.
          </p>
          <h2 className="md:text-5xl font-black mb-4 text-[28px]" data-id="element-279">
            PROTOCOLO MENTE INDOMABLE™
          </h2>
          <p className="text-brand font-bold mt-2" data-id="element-280">
            +600 páginas · 200+ ejercicios cognitivos listos · Registros de
            progreso · Evaluaciones · Protocolos de campo · Blindaje mental ·
            Gestión del hábito
          </p>
          <p className="text-gray-300 text-base max-w-2xl mx-auto mt-6" data-id="element-281">
            El sistema que entrena tu mente para los próximos 20 años. De una
            vez.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-282">
          📚 LOS 4 TOMOS — Para hombres que entrenan en serio
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-283">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-284">
              <div className="text-2xl mb-3" data-id="element-285">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-286">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-287">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px] pt-[15px] pb-[15px] pl-[15px] pr-[15px] space-x-[12px] space-y-[16px]" data-id="element-288">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-289">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-290">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-291">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-292" />
                <span className="text-gray-300 text-[16px]" data-id="element-293">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}